// extracted by mini-css-extract-plugin
module.exports = {"root":"bWayF0Ag","horizontalDivider":"C_yEG0Gx"};